import React, { useState, useEffect } from "react";
import "./Page.css";
import TagGroup from "./TagGroup";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { TagManager } from "../model/TagManager";
import { ClipboardHelper } from "../model/ClipboardHelper";
import LogoBar from "./LogoBar";

type SelectionPageProps = {
	tagManager: TagManager;
};

const SelectionPage: React.FunctionComponent<SelectionPageProps> = (
	props: SelectionPageProps
) => {
	let state = props.tagManager.readState();
	const checkTooManyTags = () => state.selectedTagCount > 30;

	const [selectedCount, setSelectedCount] = useState(state.selectedTagCount);
	const [tooManySelectedTags, setTooManySelectedTags] = useState(
		checkTooManyTags()
	);

	useEffect(() => {
		const onTagSelectionChanged = (tag: string, selected: boolean) => {
			setSelectedCount(state.selectedTagCount);
			setTooManySelectedTags(checkTooManyTags());
		};

		state.addListener(onTagSelectionChanged);

		return () => state.removeListener(onTagSelectionChanged);
	});

	const unselectAll = () => {
		state.selectedTags.forEach(tag => state.setTagSelection(tag, false));
	};

	const copyTags = () => {
		const tagsText = state.selectedTags.join(" ");
		ClipboardHelper.copyToClipboard(tagsText);
	};

	return (
		<div className="SelectionPage noselect">
			<LogoBar />
			<div className="Page-navbar w3-bar w3-top">
				<Link to="/config" className="w3-bar-item w3-button w3-left">
					<FontAwesomeIcon
						icon={faCog}
						className="Page-navbar-icon"
					/>
				</Link>
				<button
					className={
						"w3-bar-item w3-button w3-right" +
						(tooManySelectedTags ? " w3-red" : "")
					}
					onClick={copyTags}
				>
					Copy ({selectedCount})
				</button>
				{selectedCount > 0 ? (
					<button
						className="w3-bar-item w3-button w3-right"
						onClick={unselectAll}
					>
						Reset
					</button>
				) : (
					<></>
				)}
			</div>

			<div className="Page-content w3-container">
				<h1 className="w3-center">Select your tags</h1>
				{state.groups.map(item => (
					<TagGroup
						key={item.name}
						group={item}
						state={state}
						separator={item !== state.groups[0]}
					/>
				))}
			</div>
		</div>
	);
};

export default SelectionPage;
